"use strict";
angular.module('sysOperationManageServiceModule', ["manageSysManageNewSysOperationModalModule"])
    .factory("sysOperationManageService", ['$q', '$modal', "trsHttpService", function($q, $modal, trsHttpService) {
        return {
            /**
             * [edit description] 修改和新增系统配置
             * @return {[type]} [description]
             */
            edit: function(item, success) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/sysManageMent/sysOperationManagement/service/newSysOperationModal/newSysOperationModal.html",
                    windowClass: 'new-sys-operation-modal',
                    backdrop: true,
                    controller: "manageSysManageNewSysOperationModalCtrl",
                    resolve: {
                        Params: function() {
                            return item;
                        }
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            /**
             * [sort description] 系统排序
             * @param  {[object]} item    [description] 系统
             * @param  {[Function]} success [description] 成功后的回调函数
             * @return {[type]}         [description]
             */
            // sort: function(item,success) {
            //     var modalInstance = $modal.open({
            //         templateUrl: "./manageConfig/sysManageMent/sysOperationManagement/service/sortSysOperationModal/sortSysOperationModal.html",
            //         windowClass: 'sort-sys-operation-modal',
            //         backdrop: true,
            //         controller: "manageSysManagesortSysOperationModalCtrl",
            //         resolve: {
            //             Params: function() {
            //                 return item;
            //             }
            //         },
            //     });
            //     modalInstance.result.then(function(result) {
            //         success(result);
            //     });
            // }
        };
    }]);
